<div class="modal-content modal-content-right">
  <div class="modal-header">
    <h5 class="modal-title">
      <i class="fas fa-toolbox"></i>Manual Payment
      {{ paymentType == 2 ? "(Partial)" : "" }}
    </h5>
    <button type="button" class="close" (click)="close()" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="justify-content-center">
      <div class="form-row">
        <div class="form-group col-md-12">
          <label>Client</label
          ><span class="pull-right" *ngIf="isCustomerLoading"
            ><i class="fas fa-spinner fa-spin"></i
          ></span>
          <input
            type="text"
            class="form-control"
            disabled
            value="{{ clientName }}"
          />
        </div>
        <div class="form-group col-md-12">
          <label>Invoice</label
          ><span
            class="pull-right"
            *ngIf="isInvoicePartialPaymentSettingsLoading"
            ><i class="fas fa-spinner fa-spin"></i
          ></span>
          <input
            type="text"
            class="form-control"
            disabled
            value="{{ invoiceModel.invoiceNumber }}"
          />
        </div>
        <div class="form-group col-md-12">
          <label class="form-label">Payment Method</label>
          <select
            class="form-control is-invalid"
            [ngClass]="{ 'is-invalid': paymentMethod == 0 }"
            (change)="setPaymentMethod()"
            [(ngModel)]="paymentMethod"
            [ngModelOptions]="{ standalone: true }"
          >
            <option value="0">--- Select Method ---</option>
            <option value="1">Check</option>
            <option value="2">Bank Transfer</option>
            <option value="3" *ngIf="type != 'merchant'">Cash</option>
          </select>
        </div>
        <div class="form-group col-md-12">
          <label>Amount</label>
          <input
            type="text"
            class="form-control"
            [ngClass]="{
              'is-invalid': paymentType == 2 && paymentAmount == ''
            }"
            [disabled]="true"
            [ngModel]="paymentAmount | currency"
            [ngModelOptions]="{ standalone: true }"
          />
        </div>
        <div class="form-group col-md-12">
          <label class="form-label">Payment Date</label>
          <input
            type="date"
            class="form-control"
            [ngClass]="{ 'is-invalid': !isValidDate() }"
            [min]="minPaymentDate"
            (change)="setPaymentDate($event)"
            required
          />
        </div>
        <div class="form-group col-md-12">
          <label class="form-label">Transaction Reference</label>
          <input
            type="text"
            class="form-control"
            [(ngModel)]="manualPaymentModel.TransactionReference"
            required
            [ngClass]="{
              'is-invalid': !manualPaymentModel.TransactionReference
            }"
          />
        </div>
        <div class="form-group col-md-12">
          <label class="form-label">Private Notes</label>
          <textarea
            class="form-control"
            [(ngModel)]="manualPaymentModel.PrivateNotes"
          ></textarea>
        </div>
        <div class="form-group col-md-12" *ngIf="false">
          <input
            type="checkbox"
            class="form-check form-check-inline"
            [(ngModel)]="manualPaymentModel.ConvertCCy"
            [ngModelOptions]="{ standalone: true }"
          /><span>Convert Currency</span>
        </div>
        <div class="form-group col-md-12">
          <input
            type="checkbox"
            class="form-check form-check-inline"
            [(ngModel)]="manualPaymentModel.EmailReceiptToClient"
          /><span>Email Receipt to Client</span>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline" (click)="close()">
      Cancel
    </button>
    <button
      type="button"
      class="btn btn-outline"
      [disabled]="busy || !isModelValid()"
      (click)="saveManualPayment()"
    >
      Process Payment
      <span class="ml-2" *ngIf="busy"
        ><i class="fas fa-spinner fa-spin"></i
      ></span>
    </button>
  </div>
</div>
